
export const setCategoriesArr = (state,categoriesA)=>{
    state.category = categoriesA
};
export const setCategoriesDisplayArr = (state,categoriesDisplayA)=>{
    state.cateGoryDisplay = categoriesDisplayA
};